import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DataQuery from 'data/DataQuery';
import IFileService from 'data/IFileService';
import { Fueling_FuelingTransactionsExport } from 'data/endpoints';
import { formatISO } from 'date-fns';
import { FuelingTransactionViewType } from 'features/fueling/enums/fuelingTransactionViewType';
import ContractLink from 'features/invoices/components/ContractLink';
import InvoiceLineCalculationDTO from 'features/invoices/dtos/InvoiceLineCalculationDTO';
import PageCard from 'features/shared/components/card/PageCard';
import InfoItem from 'features/shared/components/infoItem/InfoItem';
import RenderWrapper from 'features/shared/components/renderWrapper/RenderWrapper';
import { formatDate, formatPrice } from 'features/shared/helpers/Formatters';
import { useInjection } from 'infrastructure/ioc/ioc.react';
import { IocTypes } from 'infrastructure/ioc/ioc.types';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  billing: InvoiceLineCalculationDTO;
  isFueling?: boolean;
}

const BillingInfoCard = ({ billing, isFueling }: Props) => {
  // DI
  const fileService = useInjection<IFileService>(IocTypes.FileService);

   // translations
  const tLabels = useTranslation("billings\\billings").t;

  // handlers
  const downloadTransactionsExcelHandler = () => {
    let query: DataQuery = {
      url: Fueling_FuelingTransactionsExport,
      params: new URLSearchParams({
        BillingId: billing.invoiceLineId!,
        From: formatISO(new Date(billing.periodFrom!), { representation: "date" }),
        To: formatISO(new Date(billing.periodTo!), { representation: "date" }),
        ViewType: FuelingTransactionViewType.FuelingCard
      }),
    };
    
    fileService.downloadFile(query);
  }  
  
  // sub-renders
  const renderContract = () => <ContractLink entityLink={billing.entityLink!} isFuelingContract={isFueling} />;

  const renderTransactionsBtn = () => { 
    return (
      <button className="btn btn-sm btn-secondary mt-2" onClick={downloadTransactionsExcelHandler}>
        <FontAwesomeIcon icon="download" />
        <span className="ml-1">{tLabels("billingInfoCard.downloadTransactions")}</span>
      </button>
    )
  }

  // render
  return (
    <PageCard title={tLabels("billingInfoCard.cardTitle")}>
      <div className="row no-gutters">
        <div className="col-sm-6 col-lg-4 px-sm-2 pb-2 pb-sm-3">
          <InfoItem title={tLabels("billingInfoCard.periodFrom")} value={formatDate(billing.periodFrom!)} icon="calendar-alt" />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-2 pb-2 pb-sm-3">
          <InfoItem title={tLabels("billingInfoCard.periodTo")} value={formatDate(billing.periodTo!)} icon="calendar-alt" />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-2 pb-2 pb-sm-3">
          <InfoItem title={tLabels("billingInfoCard.totalAmount")} value={formatPrice(billing.amount!, billing.currency!, 2)} icon="donate" />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-2 pb-2 pb-sm-3">
          <InfoItem title={tLabels("billingInfoCard.contract")} value={renderContract()} icon="file-contract"  />
        </div>
        <RenderWrapper isVisible={() => billing.hasTransactions === true}>
          <div className="col-sm-6 col-lg-4 px-sm-2 pb-2 pb-sm-3">
            <InfoItem title={tLabels("billingInfoCard.transactions")} value={renderTransactionsBtn()} icon="file-excel"  />
          </div>
        </RenderWrapper>
      </div>
    </PageCard>
  )
}

export default BillingInfoCard;
